import React, { useEffect } from "react";
import { FiChevronDown } from "react-icons/fi";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import { createJobOffer } from "../../store/thunks/offersThunk";
import Error from "../common/Error";
import InputField from "../common/InputField";
import Select from "react-select";
import Button from "../common/Button";
import { isFulfilled } from "@reduxjs/toolkit";
import RoutesPath from "../../utils/Paths";
import { useAuthContext } from "../../features/authentication";
import useGetConfigurations from "../../hooks/api/useGetConfigurations";

const SendOfferSchema = Yup.object({
  coverLetter: Yup.string().required("Cover Letter is Required"),
});

/**
 * @typedef {object} Props
 * @property {string} jobId
 * @property {{budgetMax: number, budgetMin: number}} offer
 */
const CreateJobOfferForm = (
  /** @type {Props} **/ { jobId, offer: { budgetMax, budgetMin }, jobType }
) => {
  const { user } = useAuthContext();
  const userId = user._id;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const configurations =
    useGetConfigurations();
  const {
    values,
    errors,
    touched,
    isSubmitting,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
  } = useFormik({
    initialValues: {
      coverLetter: "",
      selectedGig: "",
      price: "",
      attachments: [],
    },
    validationSchema: SendOfferSchema,
    onSubmit: async (values) => {
      const action = await dispatch(
        createJobOffer({
          files: values.attachments,
          coverLetter: values.coverLetter,
          jobId: jobId,
          uid: userId,
          jobType,
          price:0
        })
      );
      if (isFulfilled(action)) {
        navigate(RoutesPath.sentOffers);
      }
    },
  });

  return (
    <div>
      <div className="offers-section">
        <div className="d-flex justify-content-between align-items-center">
          <h5 className="mb-0">Apply for This Job</h5>
          <FiChevronDown />
        </div>
      </div>
      <div className="create-offer d-flex justify-content-center">
        <form className="form" onSubmit={handleSubmit}>
          <h5 className="text-center heading">Submit Your Application</h5>
          <div className="mb-3">
            <label className="d-block regular" htmlFor="coverLetter">
              {"Cover Letter"}
            </label>
            <textarea
              placeholder="I can..."
              name="coverLetter"
              id="coverLetter"
              value={values.coverLetter}
              onChange={handleChange}
              autoComplete="off"
            />
            {errors.coverLetter && touched.coverLetter && (
              <Error text={errors.coverLetter} />
            )}
          </div>
          
          {/* Apparently attachments are not allowed for this creating offer... Synced with Mobile-App */}
          <div className="mb-4">
            <label className="d-block regular mb-1" htmlFor="">
              Upload Resume <span className="note">(optional)</span>
            </label>
            <input
              type="file"
              id="attachments"
              name="attachments"
              onChange={(event) => {
                setFieldValue('attachments', Array.from(event.currentTarget.files));
              }}
              multiple
            />
          </div>
          <div className="d-flex justify-content-center">
            <Button type="submit" className="accept-btn">
              {isSubmitting ? (
                <div
                  className="spinner-border spinner-border-sm and spinner-grow-sm mb-0"
                  role="status"
                >
                  <span className="sr-only"></span>
                </div>
              ) : (
                "Apply Now"
              )}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateJobOfferForm;
